import { render, staticRenderFns } from "./DashboardBaseTemplate.vue?vue&type=template&id=3730d452&"
import script from "./DashboardBaseTemplate.vue?vue&type=script&lang=js&"
export * from "./DashboardBaseTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports